import groupAttrProps from "../config/group";
import productAttrProps from "@/config/product";

/**处理门店数据
 * [
 *  {region: 北培, KPI: 钻石业绩, Shop: 北碚城南周大生, sGroup: AB通班, Today: 123, MTD: 123, YTD: 123},
 *  {region: 成都, KPI: 素金业绩, Shop: 北碚城南周大生, sGroup: AB通班, Today: 123, MTD: 123, YTD: 123},
 * ]
 *
 * ==>
 *
 * groupList: [AB通班, A班]
 * todayList: [zs: 123, sj: 123]
 * mtdList: [zs: 123, sj: 123]
 * ytdList: [zs: 123, sj: 123]
 *
 * */
export function formatShopList(rows) {
  let obj = {};
  rows.forEach((v) => {
    let key = groupAttrProps[v.KPI] || v.KPI;
    if (!key) return;
    if (obj[v.sGroup]) {
      if (v.Product) {
        const k = productAttrProps[v.KPI] || v.KPI;
        if (obj[v.sGroup].today.products) {
          const index = obj[v.sGroup].today.products.findIndex(
            (item) => item.name === v.Product
          );
          if (index === -1) {
            obj[v.sGroup].today.products.push({
              name: v.Product,
              [k]: v.Today,
            });
            obj[v.sGroup].mtd.products.push({ name: v.Product, [k]: v.MTD });
            obj[v.sGroup].ytd.products.push({ name: v.Product, [k]: v.YTD });
          } else {
            obj[v.sGroup].today.products[index][k] = v.Today;
            obj[v.sGroup].mtd.products[index][k] = v.MTD;
            obj[v.sGroup].ytd.products[index][k] = v.YTD;
          }
        } else {
          obj[v.sGroup].today.products = [{ name: v.Product, [k]: v.Today }];
          obj[v.sGroup].mtd.products = [{ name: v.Product, [k]: v.MTD }];
          obj[v.sGroup].ytd.products = [{ name: v.Product, [k]: v.YTD }];
        }
      } else {
        obj[v.sGroup].today[key] = v.Today;
        obj[v.sGroup].mtd[key] = v.MTD;
        obj[v.sGroup].ytd[key] = v.YTD;
      }
    } else {
      obj[v.sGroup] = {
        today: {
          [key]: v.Today,
        },
        mtd: {
          [key]: v.MTD,
        },
        ytd: {
          [key]: v.YTD,
        },
      };
    }
  });
  let todayList = [];
  let mtdList = [];
  let ytdList = [];
  Object.keys(obj).forEach((v, i) => {
    todayList.push({ name: v, ...obj[v].today });
    mtdList.push({ name: v, ...obj[v].mtd });
    ytdList.push({ name: v, ...obj[v].ytd });
  });
  return [todayList, mtdList, ytdList];
}
